import {
  createApiFetch,
  createKindTutorAuthClient,
  resolveDevelopmentApiBaseUrl,
} from "@kindtutor/auth-client";

export const apiBaseURL = resolveDevelopmentApiBaseUrl(
  import.meta.env.VITE_API_BASE_URL ??
    (import.meta.env.DEV ? "http://localhost:8787" : window.location.origin),
  window.location.hostname,
  import.meta.env.DEV,
);

export const apiFetch = createApiFetch("school-web/0.1.0");
export const authClient = createKindTutorAuthClient(
  apiBaseURL,
  "school-web/0.1.0",
);
